
import {
  defineComponent,
  // onMounted,`
  ref,
  inject,
} from "vue";
import { Patient, educationLevels } from "@/domain/entities/Patient";
import { PatientRepository } from "@/infraestructure/patient/PatientRepository";
import { pprint } from "@/helpers/pprint";
import SelectForm from "./SelectForm.vue";
import LocationFormInput from "./LocationFormInput.vue";
import HealthForm from "./HealthForm.vue";
import useNotification from "@/store/NotificationState";
import useUser from "@/store/UserState";

enum KindSection {
  Personal,
  Health,
}

export default defineComponent({
  name: "patient-form",
  components: {
    HealthForm,
    LocationFormInput,
    SelectForm,
  },
  async setup() {
    const {user} = useUser()

    let activeSection = ref(KindSection.Personal);
    // init
    let patientRespository = inject(
      PatientRepository.key
    ) as PatientRepository;

    const { showSnackbar } = useNotification();
    async function onSave() {
      pprint(user.value);
      let err = Patient.validateNonEmptyRegistrationFields(user.value as Patient);
      pprint("err", err?.[0]);
      if (err !== undefined) {
        showSnackbar(`Campo vacío ${err[0]}`);
        return;
      }
      const patientData = user.value as Patient
      patientData.hasFilledPersonalInformation = true
      await patientRespository.updatedData(patientData);
			(user.value as Patient).hasFilledPersonalInformation = true
    }

    return {
      activeSection,
      KindSection,
      onSave,
      patient: user,
      educationLevels,
    };
  },
});
